import React from 'react';
import { motion } from 'framer-motion';
export function DemoVideo() {
  return <div className="max-w-4xl mx-auto mt-16 mb-8" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center" data-id="element-17">
        <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-18">
          Una de las técnicas que aprendés dentro del método completo
        </h3>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white bg-black aspect-video" data-id="element-19">
          <video className="w-full h-full object-cover" controls playsInline poster="https://cdn.magicpatterns.com/uploads/7F7D2Riujw9aSzBdUchq1Y/VIDEO_GLOBOS.undefined" data-id="element-20">
            <source src="https://cdn.magicpatterns.com/uploads/7F7D2Riujw9aSzBdUchq1Y/VIDEO_GLOBOS.undefined" type="video/mp4" data-id="element-21" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>
      </motion.div>
    </div>;
}